<div class="card-container-shadow">
  <p class="modified new" *ngIf="!this.tour.value">Pendiente</p>
  <div class="tw-relative container-cover">
    <img class="cover-image" loading="lazy" [src]=" '../../../assets/images/tours/' + this.tour.key + '.png'" alt="">
    <div class="preview-img" (click)="this.startTour()">
      <span nz-icon nzType="play-circle" nzTheme="outline"></span>
      <p class="tw-whitespace-nowrap tw-text-white tw-font-medium">Clic para iniciar tour</p>
    </div>

    <div class="tour-information" *ngIf="this.tourRequireDemoData.includes(this.tour.key)">
      <span nz-icon nzType="profile" nzTheme="outline"></span>
    </div>

  </div>
  <div class="tw-mt-3 tw-flex tw-justify-between">
    <p class="tw-text-gray-600 tw-text-base tw-font-medium truncate">
      {{ this.tour.key | getTranslateEnum:'tours' }}
    </p>
  </div>
</div>
